// extracted by mini-css-extract-plugin
module.exports = {"totalItems":"pagination-table_totalItems__1AxHD"};